<div class="main">
  <img class="logo" src="/assets/ukrsib_logo.png" alt="">
  <button class="logout btn btn__link" (click)="confirmToLogout()">Вийти</button>
</div>

<div class="second">
  <h1 class="title">{{ title }}</h1>
  <ng-content></ng-content>
</div>
